import React from "react";
import SectionShell from "./SectionShell";

const FEELING_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/jpl89ltv_ChatGPT%20Image%202026.%20j%C3%BAn.%2024.%2015_28_29.png";

export default function FeelingArrivesSection() {
  return (
    <SectionShell
      id="erzes"
      testId="feeling-section"
      eyebrow="Egy belső pillanat"
      titleStart="Néha megérkezik"
      titleAccent="egy érzés."
    >
      {/* Symbolic image — a quiet horizon */}
      <figure className="my-8 md:my-10">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="feeling-image"
            src={FEELING_IMAGE_URL}
            alt="Stég a tó fölött, naplemente fényében — egy csendes érzés érkezése"
            className="w-full h-auto object-cover block"
            style={{
              aspectRatio: "1 / 1",
              filter: "saturate(0.96) contrast(1.02)",
            }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Néha megérkezik egy érzés. Nem feltétlenül arról, hogy valami hiányzik. Sokkal
        inkább arról, hogy van bennünk valami, ami szeretne nagyobb teret kapni. Egy
        élethelyzet, egy kapcsolat, egy vágy vagy egy régóta halogatott döntés. Esetleg
        egyszerűen csak a felismerés, hogy az élet több lehetőséget tartogat annál, mint
        amennyit jelenleg látunk belőle. Amelyet nem mindig a nehézségek mutatnak meg.
        Néha egy csendes belső tudás formájában érkezik. Egy érzésként, amely felhívja a
        figyelmünket arra, hogy ideje közelebb lépni ahhoz, akik valójában lehetnénk.
      </p>
    </SectionShell>
  );
}
